import { Card, Typography, Box } from "@mui/material";
import { Service } from "../../context/scope-of-work.types";
import { colors, alphaVar } from "../../../../../../ui/colors";

const COLORS = {
  orange: {
    base: colors.orange.base,
    50: "#FFF3E8",
    100: "#FFE0C2",
    700: colors.orange[700],
  },
  gray: {
    100: "#F3F4F6",
    300: "#D1D5DB",
    500: "#6B7280",
  },
};

interface TypeOfServiceCardProps {
  service: Service;
  onSelect: (service: Service) => void;
  selected: Service | null;
}

export const TypeOfServiceCard = ({ service, onSelect, selected }: TypeOfServiceCardProps) => {
  const isSelected = selected?.uid === service.uid;

  return (
    <Card
      onClick={() => onSelect(service)}
      sx={{
        backgroundColor: isSelected ? alphaVar(COLORS.orange[50], 0.7) : "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 2,
        border: `2px solid ${isSelected ? COLORS.orange.base : alphaVar(COLORS.gray[100], 0.8)}`,
        boxShadow: isSelected ? `0 3px 8px ${alphaVar(COLORS.orange.base, 0.25)}` : "0 1px 2px rgba(0,0,0,0.05)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: `0 3px 6px ${alphaVar(COLORS.orange.base, 0.15)}`,
          borderColor: alphaVar(COLORS.orange.base, 0.3),
        },
        width: 200,
        height: 200,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        p: 1.5,
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,
          color: COLORS.orange.base,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "auto auto",
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={service.imageUrl}
          alt={service.name}
          sx={{
            width: 120,
            height: 120,
            marginTop: 4,
            objectFit: "contain",
          }}
        />
      </Box>

      <Typography
        variant="subtitle2"
        fontWeight={700}
        sx={{
          color: isSelected ? COLORS.orange[700] : COLORS.gray[500],
          fontSize: 13,
          lineHeight: 1.1,
          mb: 3,
          marginTop: 5,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {service.name}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          marginTop: -2,
          color: COLORS.gray[300],
          fontSize: 11,
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {service.description}
      </Typography>
    </Card>
  );
};